import { ComponentProps, ReactNode, useRef } from 'react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper } from 'swiper/react';

import styles from '@components/Slides.module.css';
import Icon from '@components/text/Icon';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

type Props = ComponentProps<typeof Swiper> & {
  children: ReactNode;
  hideNavigation?: boolean;
  overrideNavigationLeft?: string;
  overrideNavigationRight?: string;
  overrideNavigationTop?: string;
};

const Slides = ({
  children,
  hideNavigation,
  overrideNavigationLeft,
  overrideNavigationRight,
  overrideNavigationTop,
  ...swiperProps
}: Props) => {
  const navigationNextRef = useRef<HTMLDivElement>(null);
  const navigationPrevRef = useRef<HTMLDivElement>(null);

  return (
    <div className={styles.relativeWrapper}>
      <Swiper
        className={styles.slides}
        modules={[Autoplay, Navigation, Pagination]}
        navigation={{
          disabledClass: styles.disabled,
          nextEl: navigationNextRef.current,
          prevEl: navigationPrevRef.current
        }}
        observeParents
        observer
        pagination
        preventClicks
        style={{
          // @ts-ignore
          // eslint-disable-next-line @typescript-eslint/naming-convention
          '--swiper-navigation-size': '25px',
          marginRight: 44
        }}
        {...swiperProps}
      >
        {children}
      </Swiper>
      {!hideNavigation && (
        <>
          <div
            className={styles.left}
            ref={navigationPrevRef}
            style={{
              left: overrideNavigationLeft ? overrideNavigationLeft : undefined,
              top: overrideNavigationTop ? overrideNavigationTop : undefined
            }}
          >
            <Icon color="primary" icon="chevronLeft" />
          </div>
          <div
            className={styles.right}
            ref={navigationNextRef}
            style={{
              right: overrideNavigationRight ? overrideNavigationRight : undefined,
              top: overrideNavigationTop ? overrideNavigationTop : undefined
            }}
          >
            <Icon color="primary" icon="chevronRight" />
          </div>
        </>
      )}
    </div>
  );
};

export default Slides;
